import React, { useState, useEffect } from "react";
import FirmaContent from "./AccordionSections/FirmaContent";
import RevisionContent from "./AccordionSections/RevisionContent";
import DocsContent from "./AccordionSections/DocsContent";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@mui/material/";

// ICONS OPEN
import {
  AccessTime,
  ExpandMore,
  WarningAmber,
  History,
  Close,
  Send,
  Mail,
} from "@mui/icons-material";
import { quitarTildes, statusConfig } from "../../Components/helpers/Helpers";
import { CustomIconsPlusText } from "../../Components/Common/Design/CustomIconsPlusText";
import StepsForm from "./AccordionSections/StepsForm";
import api from "../../api/axios";
import FormFI from "../Components/FormFI";
// ICONS CLOSED

const FlowSectionAccordion = ({
  dataCase,
  caseContract,
  acceptedContract,
  caseId,
  userLogged,
  mailTemplates,
  updatedCase,
  setUpdatedCase,
  glassSurface,
  contactConditionIfExist,
  requireContractAssignment,
  contractsList,
  newContract,
  contractInputValue,
  setNewContract,
  setContractInputValue,
  handleConfirmNewContract,
}) => {
  const Swal = require("sweetalert2");
  const [expanded, setExpanded] = useState(false);
  const [changed, setChanged] = useState(false);

  const reconstructedFlow = React.useMemo(() => {
    const tasksById = new Map(
      (dataCase?.tasks || []).map((task) => [Number(task?.task_id), task]),
    );

    return [...(dataCase?.completeFlow || [])]
      .sort((a, b) => Number(a?.order ?? 0) - Number(b?.order ?? 0))
      .map((flow, index) => {
        const task = tasksById.get(Number(flow?.id));

        return {
          ...flow,
          task_id: task?.task_id ?? flow?.id,
          status: task ? Number(task.status) : null,
          date_in: task?.date_in ?? flow?.date_in ?? "",
          date_end: task?.date_end ?? flow?.date_end ?? "",
          date_update: task?.date_update ?? flow?.date_update ?? "",
          config: task?.config ?? flow?.config ?? null,
          message: task?.message ?? flow?.message ?? "",
          order: Number(flow?.order ?? index + 1),
        };
      });
  }, [dataCase?.completeFlow, dataCase?.tasks]);

  //  construimos taskFlow cada vez que cambie dataCase
  const taskFlow = React.useMemo(() => {
    const obj = {};
    reconstructedFlow.forEach((flow) => {
      obj[flow.id] = {
        status: flow.status,
        date_in: flow.date_in,
        date_end: flow.date_end,
        date_update: flow.date_update !== "" ? flow.date_update : "",
        config: flow.config,
        message: flow.message,
        id: flow.id,
        task_id: flow.task_id,
      };
    });
    return obj;
  }, [reconstructedFlow]);

  const nextTask = async (
    config,
    task_status,
    status_desicion,
    message,
    anotherTask,
  ) => {
    let ultimo;

    try {
      // console.log(anotherTask, dataCase?.task?.task_id);
      const currentTaskId = Number(anotherTask || dataCase?.task?.task_id || 0);

      if (!currentTaskId) {
        Swal.fire({
          title: "Error",
          text: "No se pudo identificar la tarea actual.",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "Cerrar",
        });

        return;
      }

      // console.log("Tarea actual:", currentTaskId);
      // console.log("anotherTask:", anotherTask);
      // console.log("dataCase.task:", dataCase?.task?.task_id);

      if (status_desicion === "lastone") {
        ultimo = dataCase?.completeFlow?.[dataCase.completeFlow.length - 1];
      }

      Swal.fire({
        title: "Cargando...",
        html: '<div class="swal-loader"></div>',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      let nextId;
      let nextTime;

      /*
       * Buscamos la siguiente tarea PARTIENDO EXCLUSIVAMENTE
       * de la tarea actual.
       */
      for (let i = 0; i < dataCase?.completeFlow?.length; i++) {
        const element = dataCase.completeFlow;

        if (currentTaskId === Number(element[i]?.id)) {
          nextId = element[i + 1]?.id;
          nextTime = element[i + 1]?.status_user_max_delay;
          break;
        }
      }

      const hasNextTask = !!nextId;

      if (status_desicion === "next" && !hasNextTask) {
        Swal.close();

        Swal.fire({
          title: "Flujo completado",
          text: "No existen más tareas en este caso.",
          icon: "info",
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Aceptar",
        });

        return;
      }

      /*
       * Datos para actualizar la tarea.
       *
       * current_task = SIEMPRE la tarea desde la que estamos avanzando.
       */
      const payload = {
        case_status: ultimo?.id
          ? ultimo.id
          : !status_desicion || status_desicion === "next"
            ? nextId
            : currentTaskId,

        case_id: Number(caseId),

        task_id: ultimo?.id ? ultimo.id : nextId,

        status: task_status,

        config: JSON.stringify(config),

        next_config: JSON.stringify({}),

        current_task: currentTaskId,

        update_desicion: status_desicion,

        status_user_max_delay: ultimo?.id ? ultimo.id : nextTime,

        client_name: dataCase?.full_client_name,
      };

      /*
       * Si hay mensaje, lo agregamos.
       */
      if (message !== "") {
        payload.message = JSON.stringify(message);
      } else {
        payload.message = "";
      }

      // console.log("Payload:", payload);
      // console.log("CURRENT TASK:", currentTaskId);
      // console.log("NEXT TASK:", nextId);

      /*
       * FormData
       */
      const formDataTask = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        formDataTask.append(key, value);
      });

      const urlTask = `${process.env.REACT_APP_API_URL}/casestasks/nexttask`;

      await api.post(urlTask, formDataTask);

      setUpdatedCase((prev) => !prev);

      Swal.close();

      Swal.fire({
        title: "Guardado",
        text: "La tarea ha sido actualizada correctamente",
        icon: "success",
        timer: 2000,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      }).then((result) => {
        if (result.isConfirmed) {
          setChanged((prev) => !prev);
        }
      });
    } catch (err) {
      Swal.close();

      let errorMessage = "Ocurrió un error inesperado. Intenta nuevamente.";

      if (err.response) {
        errorMessage = err.response.data?.message || "Error en el servidor.";
      } else if (err.request) {
        errorMessage = "No hay conexión con el servidor. Revisa tu red.";
      } else {
        errorMessage = `Error: ${err.message}`;
      }

      console.error("Error en nextTask:", err);

      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar",
      });
    }
  };

  useEffect(() => {
    const flowOrderMap = new Map(
      (reconstructedFlow || []).map((flow) => [
        Number(flow?.id),
        Number(flow?.order || 0),
      ]),
    );

    const activeTasks = (dataCase?.tasks || [])
      .filter((task) => task?.task_id != null)
      .map((task) => ({
        taskId: Number(task?.task_id),
        status: Number(task?.status ?? -1),
        order: Number(flowOrderMap.get(Number(task?.task_id)) ?? 0),
      }))
      .filter((task) => task.taskId > 0 && task.order > 0);

    // La sección abierta del flujo debe corresponder a la tarea actual activa,
    // priorizando primero la última pendiente y luego la última activa por orden.
    const lastPendingTask = [...activeTasks]
      .filter((task) => task.status === 0)
      .sort((a, b) => b.order - a.order)[0];

    const latestActiveTask = [...activeTasks].sort(
      (a, b) => b.order - a.order,
    )[0];

    const preferredTaskId =
      lastPendingTask?.taskId ??
      latestActiveTask?.taskId ??
      Number(dataCase?.latest_task?.task_id ?? dataCase?.task?.task_id ?? 0);

    setExpanded(preferredTaskId || false);
  }, [
    reconstructedFlow,
    dataCase?.latest_task,
    dataCase?.task,
    dataCase?.tasks,
  ]);

  return (
    <Grid container item xs={12} md={12} m={"auto"} sx={glassSurface}>
      <Box
        sx={{
          p: { xs: "10px", md: "10px" },
        }}
      >
        {reconstructedFlow?.map((section, index) => {
          const taskData = taskFlow[section.id];
          const hasDate = !!taskData?.date_update;
          const date = hasDate ? new Date(taskData.date_update) : null;

          const year =
            date && !Number.isNaN(date.getTime()) ? date.getFullYear() : null;
          const month =
            date && !Number.isNaN(date.getTime())
              ? String(date.getMonth() + 1).padStart(2, "0")
              : null;
          const day =
            date && !Number.isNaN(date.getTime())
              ? String(date.getDate()).padStart(2, "0")
              : null;

          const formattedDate =
            year && month && day ? `${day}/${month}/${year}` : "Nunca";
          const isFirstSection = index === 0;
          const isLastSection =
            index === (dataCase?.completeFlow?.length || 1) - 1;
          const accordionRadius =
            isFirstSection && isLastSection
              ? "12px"
              : isFirstSection
                ? "12px 12px 0 0"
                : isLastSection
                  ? "0 0 12px 12px"
                  : "0";

          const summaryRadius = isFirstSection ? "12px 12px 0 0" : "0";

          return (
            <Accordion
              key={index}
              style={{
                width: "100%",
                mb: 0,
                overflow: "hidden",
                borderRadius: accordionRadius,
                borderTopLeftRadius: isFirstSection ? "12px" : 0,
                borderTopRightRadius: isFirstSection ? "12px" : 0,
                borderBottomLeftRadius: isLastSection ? "12px" : 0,
                borderBottomRightRadius: isLastSection ? "12px" : 0,
              }}
              expanded={expanded === section.id}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel${index + 1}-content`}
                id={`panel${index + 1}-header`}
                onClick={() =>
                  setExpanded(expanded === section.id ? false : section.id)
                }
                sx={{
                  background: "rgba(255, 255, 255, 0.55)",
                  borderRadius: summaryRadius,
                  borderTopLeftRadius: isFirstSection ? "12px" : 0,
                  borderTopRightRadius: isFirstSection ? "12px" : 0,
                  "& .MuiAccordionSummary-content": {
                    // my: 1.25,
                  },
                }}
              >
                <b className="infoStyle" style={{ marginRight: "10px" }}>
                  {index + 1 + ". " + section.status_name + " "}
                </b>

                {/* Última actualización */}
                {taskData?.date_update ? (
                  <CustomIconsPlusText
                    icon={History}
                    styles={{ width: "15px", height: "15px" }}
                    text={`Última actualización: ${formattedDate}`}
                  />
                ) : (
                  <CustomIconsPlusText
                    icon={Close}
                    styles={{ width: "15px", height: "15px" }}
                    text={`Nunca`}
                  />
                )}

                {/* Estado */}
                {taskData?.status !== undefined && taskData?.status !== null
                  ? (() => {
                      const state = Number(taskData.status);
                      const config = statusConfig[state];

                      const currentFlowOrder = Number(
                        dataCase?.flow?.order || 0,
                      );
                      const sectionOrder = Number(section?.order || 0);
                      if (
                        sectionOrder <= currentFlowOrder &&
                        taskData?.status !== 0
                      ) {
                        return (
                          <CustomIconsPlusText
                            icon={config?.icon || Close}
                            severity={config?.severity}
                            variant={config?.variant}
                            styles={{ width: "15px", height: "15px" }}
                            text={
                              config
                                ? config.text(section?.status_name)
                                : "No iniciado"
                            }
                          />
                        );
                      }
                    })()
                  : null}

                {/* Fecha límite */}
                {taskData?.status === 0 &&
                  (() => {
                    const currentFlowOrder = Number(dataCase?.flow?.order || 0);
                    const sectionOrder = Number(section?.order || 0);

                    // La etapa ya quedó atrás
                    if (sectionOrder < currentFlowOrder) {
                      return (
                        <CustomIconsPlusText
                          icon={Close}
                          severity="info"
                          styles={{ width: "15px", height: "15px" }}
                          text="Nunca"
                        />
                      );
                    }

                    // El timer solo aparece para la etapa actual
                    if (
                      sectionOrder === currentFlowOrder &&
                      taskData?.date_end
                    ) {
                      const now = new Date();
                      const end = new Date(taskData.date_end);

                      const diffDays = Math.ceil(
                        (end - now) / (1000 * 60 * 60 * 24),
                      );

                      if (diffDays > 5) {
                        return (
                          <CustomIconsPlusText
                            icon={AccessTime}
                            severity="info"
                            styles={{ width: "15px", height: "15px" }}
                            text={`${diffDays} días para finalizar la tarea`}
                          />
                        );
                      }

                      if (diffDays > 0) {
                        return (
                          <CustomIconsPlusText
                            blink="blinking"
                            variant="filled"
                            icon={WarningAmber}
                            severity="warning"
                            styles={{ width: "15px", height: "15px" }}
                            text={`${diffDays} días para finalizar la tarea`}
                          />
                        );
                      }

                      return (
                        <CustomIconsPlusText
                          blink="blinking"
                          icon={WarningAmber}
                          severity="error"
                          variant="filled"
                          styles={{ width: "15px", height: "15px" }}
                          text={`Tarea vencida hace ${Math.abs(diffDays)} días`}
                        />
                      );
                    }

                    return null;
                  })()}

                {/* Solicitud y notificación */}
                {taskData?.status === 0 &&
                  Number(section?.order || 0) >=
                    Number(dataCase?.flow?.order || 0) &&
                  !/Firma|Documentacion|Revision|Finalizado/.test(
                    section.status_name,
                  ) &&
                  (() => {
                    let config = null;

                    try {
                      config = taskData?.config
                        ? JSON.parse(taskData.config)
                        : null;
                    } catch {
                      config = null;
                    }

                    if (config?.solicitud || config?.notificacion) {
                      return (
                        <>
                          <CustomIconsPlusText
                            icon={Send}
                            severity="success"
                            styles={{ width: "15px", height: "15px" }}
                            text={`Solicitud ${section.status_name} realizada ${config.solicitud.date}`}
                          />

                          {config?.notificacion ? (
                            <CustomIconsPlusText
                              icon={Mail}
                              severity="success"
                              styles={{ width: "15px", height: "15px" }}
                              text={`Notificación ${section.status_name} recibida ${config.notificacion.date}`}
                            />
                          ) : (
                            <CustomIconsPlusText
                              icon={AccessTime}
                              severity="warning"
                              styles={{ width: "15px", height: "15px" }}
                              text={`Pendiente recibir notificación ${section.status_name}`}
                            />
                          )}
                        </>
                      );
                    } else {
                      return (
                        <CustomIconsPlusText
                          icon={AccessTime}
                          severity="warning"
                          styles={{ width: "15px", height: "15px" }}
                          text={`Pendiente Solicitud ${section.status_name}`}
                        />
                      );
                    }
                  })()}
              </AccordionSummary>
              {/* {console.log(quitarTildes(section.status_name))} */}
              <AccordionDetails>
                {(() => {
                  const sectionName = quitarTildes(section.status_name);
                  const sectionAction = section.status_action;

                  const fiCondition =
                    sectionName === "formulario fi" ||
                    sectionName === "form_fi";

                  switch (true) {
                    case sectionName === "firma":
                      return section.order <= dataCase?.flow?.order ? (
                        <FirmaContent
                          rerender={changed ? "firma-1" : "firma-0"}
                          viewMode="lawyer-flow"
                          caseContract={caseContract}
                          flagAcceptReject={
                            section.id === dataCase?.task?.task_id || false
                          }
                          acceptedContract={acceptedContract}
                          nextTask={nextTask}
                          activeTask={taskData}
                          setUpdatedCase={setUpdatedCase}
                          updatedCase={updatedCase}
                          dataCase={dataCase}
                          usersFlag={true}
                          contactConditionIfExist={contactConditionIfExist}
                          requireContractAssignment={requireContractAssignment}
                          contractsList={contractsList}
                          newContract={newContract}
                          contractInputValue={contractInputValue}
                          setNewContract={setNewContract}
                          setContractInputValue={setContractInputValue}
                          handleConfirmNewContract={handleConfirmNewContract}
                        />
                      ) : null;
                    case (sectionName === "documentacion" ||
                      sectionAction === "expedientes/docs") &&
                      !fiCondition:
                      return (
                        <DocsContent
                          sectionId={section.id}
                          caseId={caseId}
                          activeFlow={section}
                          nextTask={nextTask}
                          userLogged={userLogged}
                          dataCase={dataCase}
                          setUpdatedCase={setUpdatedCase}
                          updatedCase={updatedCase}
                          activeTask={taskData}
                        />
                      );
                    // section.order <= dataCase?.flow?.order &&
                    //   dataCase?.task?.status != 2 ? (

                    // ) : null;
                    case fiCondition:
                      if (
                        section.order <= dataCase?.flow?.order &&
                        dataCase?.task?.status !== 2
                      ) {
                        return (
                          <FormFI
                            sectionId={section.id}
                            caseId={caseId}
                            nextTask={nextTask}
                            userLogged={userLogged}
                            dataCase={dataCase}
                            setUpdatedCase={setUpdatedCase}
                            updatedCase={updatedCase}
                            activeTask={taskData}
                          />
                        );
                      } else {
                        return null;
                      }
                    case sectionName === "revision":
                      return section.order <= dataCase?.flow?.order &&
                        dataCase?.task?.status !== 2 ? (
                        <RevisionContent
                          mailTemplatesData={mailTemplates}
                          nextTask={nextTask}
                          dataCase={dataCase}
                          userLogged={userLogged}
                          caseId={caseId}
                          setUpdatedCase={setUpdatedCase}
                          updatedCase={updatedCase}
                          activeTask={taskData}
                          sectionId={section.id}
                        />
                      ) : null;
                    default: {
                      const isCurrentOrPreviousStep =
                        Number(section?.order ?? 0) <=
                        Number(dataCase?.flow?.order || 0);
                      const shouldRenderDefaultFlow =
                        isCurrentOrPreviousStep &&
                        (!taskData || dataCase?.task?.status === 0);

                      return (
                        <>
                          {shouldRenderDefaultFlow && (
                            <StepsForm
                              mailTemplatesData={mailTemplates}
                              nextTask={nextTask}
                              dataCase={dataCase}
                              caseId={caseId}
                              setUpdatedCase={setUpdatedCase}
                              updatedCase={updatedCase}
                              activeFlow={section}
                              activeTask={taskData}
                              userLogged={userLogged}
                            />
                          )}
                        </>
                      );
                    }
                  }
                })()}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Grid>
  );
};

export default FlowSectionAccordion;
